<div #inputSelect class="o-keywordsearch__content o-keywordsearch__content--fade-in"
	[ngClass]="{'o-keywordsearch__content--faded': appInitialized}">
	<ng-template [ngIf]="appInitialized && terrificHasBootstrapped && !errorHasOccured">
		<div class="o-keywordsearch__filters-container o-keywordsearch__filters-container-noshadow">
			<div
				class="o-keywordsearch__filter-controls-container o-keywordsearch__filter-controls-container--brand-market">

				<div
					class="o-keywordsearch__filter-control o-keywordsearch__filter-control--keyword-search o-keywordsearch__filter-control--keyword-search-right">
					<cov-filter-keywordsearch [modifier]="keySearchConfig?.modifier" [searchButtonText]="searchButtonText"
						[keySearchConfig]="autosuggestSearchConfig" [lang]="keySearchConfig?.lang"
						[placeholder]="keySearchConfig?.placeholder"
						[searchText]="searchText"
						(searchChanges)="onSearchChanges($event)">
					</cov-filter-keywordsearch>
				</div>
			</div>
		</div>
		<div class="o-keywordsearch__result-info-container o-keywordsearch__result-info-container--narrow-space">
			<div class="o-keywordsearch__result-info">
				<cov-heading [level]="keywordCountHeadingLevel" [modifier]="keywordCountHeadingModifier"
					[text]="keywordCountHeadingText" [class]="keywordCountHeadingClass" *ngIf="showResults()">
				</cov-heading>
				<ng-template [ngIf]="favicon">
					<cov-button [class]="'m-favourite-button m-favourite-button__icon'" (click)="favouriteFinder()">
					</cov-button>
				</ng-template>
			</div>
		</div>
	</ng-template>
</div>

<cov-loading-indicator *ngIf="(!appInitialized || !terrificHasBootstrapped) && !errorHasOccured">
</cov-loading-indicator>
<cov-message-box [message]="keySearchConfig.errorMessage" *ngIf="errorHasOccured">
</cov-message-box>